import { IndicatorBadge } from '@/components/Atoms/IndicatorBadge/IndicatorBadge';
import { ContactFormLink } from '@/components/Molecules/ContactUsFormLink/ContactFormLink';
import { useNavigationContext } from '@/contexts/NavigationContext/NavigationContext';
import useTranslation from '@/hooks/useTranslation';
import { buildTrackingObject } from '@/services/Analytics/bbAnalyticsTrackers';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import type { FCl } from 'react-fc';
import styled from 'styled-components';

export const AccountMenuList: FCl = ({ className }) => {
    const { notificationBadge } = useNavigationContext();
    const { t } = useTranslation('common');

    let itemsBadge = null;
    let whatsNewBadge = null;
    let myItemsurl = '/saved-items';

    if (notificationBadge?.myItemsCombinedCount) {
        itemsBadge = <PositionedIndicatorBadge>{notificationBadge.myItemsCombinedCount}</PositionedIndicatorBadge>;
        if (notificationBadge.savedItemCount === 0) {
            myItemsurl = '/exports';
        }
    }
    if (notificationBadge?.whatsNewCount) {
        whatsNewBadge = <PositionedIndicatorBadge>{notificationBadge.whatsNewCount}</PositionedIndicatorBadge>;
    }

    return (
        <List className={className}>
            <li>
                <a
                    data-analytics-tracking={buildTrackingObject(
                        TrackingAction.FollowLink,
                        TrackingCategory.Navigation,
                        'Navigation: Account: My Items'
                    )}
                    href={myItemsurl}
                >
                    {t('SiteSection.my_items')}
                </a>
                {itemsBadge}
            </li>
            <li>
                <a
                    data-analytics-tracking={buildTrackingObject(
                        TrackingAction.FollowLink,
                        TrackingCategory.Navigation,
                        'Navigation: Account: What is New'
                    )}
                    href="/whats-new"
                >
                    {t('SiteSection.whats_new')}
                </a>
                {whatsNewBadge}
            </li>
            <li>
                <a
                    data-analytics-tracking={buildTrackingObject(
                        TrackingAction.FollowLink,
                        TrackingCategory.Navigation,
                        'Navigation: Account: Account and Preferences'
                    )}
                    href="/account"
                >
                    {t('SiteSection.account_and_preferences')}
                </a>
            </li>
            <li>
                <a
                    data-analytics-tracking={buildTrackingObject(
                        TrackingAction.FollowLink,
                        TrackingCategory.Navigation,
                        'Navigation: Account: Help Center'
                    )}
                    href="/help"
                >
                    {t('SiteSection.help')}
                </a>
            </li>
            <li>
                <ContactFormLink
                    data-analytics-tracking={buildTrackingObject(
                        TrackingAction.FollowLink,
                        TrackingCategory.Navigation,
                        'Navigation: Account: ContactBNEF'
                    )}
                >
                    {t('Navigation.contact')}
                </ContactFormLink>
            </li>
            <li>
                <a
                    data-analytics-tracking={buildTrackingObject(
                        TrackingAction.FollowLink,
                        TrackingCategory.Navigation,
                        'Navigation: Account: Logout'
                    )}
                    href="/logout"
                >
                    {t('Navigation.logout')}
                </a>
            </li>
        </List>
    );
};

const List = styled.ul`
    > li {
        position: relative;
        &:not(:last-child) {
            margin-bottom: var(--size-grid-half);
        }
        > a,
        > button {
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        }
    }
`;

const PositionedIndicatorBadge = styled(IndicatorBadge)`
    position: absolute;
    left: 100%;
    margin-left: 4px;
`;
